import React, { Fragment, useCallback, useEffect, useState } from 'react';

import { WsSalesSolutionItem } from '../../../core';

import { WsSalesSolutionTeamPyramid, WsSalesSolutionTeamTable } from './SolutionComponents';
import { Loading } from "../../Shared";
import { WsSalesSolutionOfferingRoleClass, getSalesCapabilityRolesFromConfig } from "../../../core-sales";
import { getConfigValue } from "./helpers";




type WsSalesSolutionPeopleProps = {
  items: WsSalesSolutionItem[];
  startDate: Date;
};

const WsSalesSolutionPeople = (props: WsSalesSolutionPeopleProps) => {

  const [ roles, setRoles ] = useState<WsSalesSolutionOfferingRoleClass[] | undefined>(undefined);

  useEffect(() => {

    setTimeout(async () => {

      const salesCapabilityRoles = await getConfigValue('roles', 'admin');

      if (salesCapabilityRoles && salesCapabilityRoles.roles) {
        setRoles(getSalesCapabilityRolesFromConfig(salesCapabilityRoles.roles));
      }

    }, 250);

  }, []);

  if (roles) {

    return (<div>
      <div className="ws-sales-solution-team-composition" style={{ width: '600px', marginLeft: 'auto', marginRight: 'auto' }}>
        <div className="columns">
          <div className="column">
            <WsSalesSolutionTeamTable title="Total Team" items={props.items} team="" staticRoles={roles} startDate={props.startDate} />
            <br />
            <WsSalesSolutionTeamPyramid title="Overall Team" items={props.items} team="" location="" staticRoles={roles} startDate={props.startDate} />
          </div>
          <div className="column">
            <WsSalesSolutionTeamTable title="Avanade Team" items={props.items} team="AVANADE" staticRoles={roles} startDate={props.startDate} />
            <br />
            <WsSalesSolutionTeamPyramid title="Avanade Team" items={props.items} team="AVANADE" staticRoles={roles} location="" startDate={props.startDate} />
          </div>
          {/* <div className="column">
            <WsSalesSolutionTeamTable title="Accenture Team" items={props.items} team="ACCENTURE" />
            <br />
            <WsSalesSolutionTeamPyramid title="Accenture Team" items={props.items} team="ACCENTURE" location="" />
          </div> */}
        </div>
        <div className="columns">
          <div className="column"></div>
          <div className="column">
            <br />
            <WsSalesSolutionTeamPyramid title="Avanade UK Team" items={props.items} team="AVANADE" location="ONSHORE_UK" staticRoles={roles} startDate={props.startDate} />
          </div>
          {/* <div className="column">
            <br />
            <WsSalesSolutionTeamPyramid title="Accenture UK Team" items={props.items} team="ACCENTURE" location="ONSHORE_UK" />
          </div> */}
        </div>
        <div className="columns">
          <div className="column"></div>
          <div className="column">
            <br />
            <WsSalesSolutionTeamPyramid title="Avanade Offshore Team" items={props.items} team="AVANADE" location="OFFSHORE_INDIA" staticRoles={roles} startDate={props.startDate} />
          </div>
          {/* <div className="column">
            <br />
            <WsSalesSolutionTeamPyramid title="Accenture Offshore Team" items={props.items} team="ACCENTURE" location="OFFSHORE_INDIA" />
          </div> */}
        </div>
      </div>
    </div>);

  } else {
    return <Loading/>;
  }
};




export {
  WsSalesSolutionPeople
};
